import { afterNextRender, ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, input, Input, signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { timer } from 'rxjs';
import { createDiagnosisForm, Question } from 'src/app/components/diagnosis/diagnosis.form';
import { DiagnosisService } from 'src/app/components/diagnosis/diagnosis.service';

@Component({
  selector: 'app-diagnosis',
  imports: [
    FormsModule,
    MatProgressBarModule,
    MatStepperModule
  ],
  templateUrl: './diagnosis.component.html',
  styleUrl: './diagnosis.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiagnosisComponent {
  readonly #diagnosisService = inject(DiagnosisService);
  readonly #cd = inject(ChangeDetectorRef);

  readonly form = createDiagnosisForm();

  readonly percentage = signal(0);

  readonly nextStepUrl = input.required<string>();

  readonly stepper = viewChild.required<MatStepper>('stepper');

  constructor() {
    const destroyRef = inject(DestroyRef);
    afterNextRender(() => {
      this.stepper().selectedIndexChange
        .pipe(takeUntilDestroyed(destroyRef))
        .subscribe(() => {
          this.#setProgress();
        });

      this.#setProgress();
    });
  }

  next(question: Question) {
    timer(100)
      .subscribe(() => {
        this.stepper().selectedIndex = question.index;
      });
    this.#cd.markForCheck();
    if (question.index === this.stepper().steps.length - 1) {
      timer(2500)
        .subscribe(() => {
          this.#diagnosisService.execute(this.form.formValue)
            .subscribe((res: number) => {
              sessionStorage.setItem('counseling', JSON.stringify({ diagnosis: this.form.formValue }));
              const symbol = this.nextStepUrl().indexOf('?') === -1 ? '?' : '&';
              window.location.href = `${this.nextStepUrl()}${symbol}type=${res}`;
            });
        });
    }
  }

  prev() {
    if (this.stepper().selectedIndex === 0) {
      history.back();
      return;
    }
    this.stepper().selectedIndex = this.stepper().selectedIndex - 1;
  }

  #setProgress() {
    const totalSteps = this.stepper().steps.length - 1;
    const currentStep = this.stepper().selectedIndex + 1;
    const percentage = Math.floor(Math.min(100, (currentStep / totalSteps) * 100));
    this.percentage.set(percentage);
  }
}
